import { IFormattedFinanceOptions } from 'cng-common/helpers/numbers'

export const typesOfGeoXAxis = ['Country', 'GeoMarket']
export const GLOBAL_PREFIX = 'Global'
export const DISTRIBUTOR_PREFIX = 'Distributor'
export const POWER_ELITE_FLAG = 'PE'
export const POLY_CATEGORY = 'jbp-pc-poly'

export const URL_REPORT_FYEAR_PARAMETER = 'fYear'
export const URL_REPORT_QTR_PARAMETER = 'quarter'
export const URL_REPORT_RTM_PARAMETER = 'rtm'

export const OTHER_PARTNER_FLAG = 'Other'

export const QUARTERS_IN_CHART = 8
export const QUARTER = 4

export const FINANCIAL_VALUE_FORMAT_OPTIONS: IFormattedFinanceOptions = {
  maximumFractionDigits: 1,
  minimumFractionDigits: 1,
}
